import React from 'react';
import { Grid, Radio, makeStyles } from '@material-ui/core';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { DateField } from '~/modules/common/components';
import { ChangeResourceUserModificationType } from '~/types';
import { getAriaLabel } from '~/modules/common/util';

const useStyles = makeStyles(theme => ({
  container: {
    paddingBottom: theme.spacing(2)
  },
  asOfSection: {
    flexGrow: 0,
    maxWidth: '53%',
    flexBasis: '53%',
    paddingLeft: `${theme.spacing(0)}px !important`,
    paddingRight: `${theme.spacing(4)}px !important`,
    marginLeft: theme.spacing(-0.25),
    flexWrap: 'nowrap'
  },
  changeEntireSection: {
    flexGrow: 0,
    maxWidth: '47%',
    flexBasis: '47%',
    paddingLeft: `${theme.spacing(2.25)}px !important`
  },
  root: {
    width: '75%',
    '&.MuiFormControl-root': {
      width: '75%'
    }
  }
}));

export const ChangeResourceAllocationRangeOptions = ({
  asOfDate,
  modificationType,
  onChangeTypeSelect,
  onAsOfDateChange
}) => {
  const { formatMessage } = useIntl();
  const classes = useStyles();

  return (
    <Grid item container className={classes.container}>
      <Grid item container className={classes.asOfSection}>
        <Radio
          checked={modificationType === ChangeResourceUserModificationType.Asof}
          color="primary"
          inputProps={getAriaLabel(
            formatMessage({ id: 'changeResourceDialog.changeAsOf' })
          )}
          name="modificationType"
          onChange={onChangeTypeSelect}
          value={ChangeResourceUserModificationType.Asof}
        />
        <DateField
          ariaLabel={formatMessage({
            id: 'changeResourceDialog.asOfDate'
          })}
          clearable={false}
          editable
          fullWidth
          label={formatMessage({
            id: 'changeResourceDialog.changeAsOf'
          })}
          onChange={onAsOfDateChange}
          value={asOfDate}
          variant="filled"
          useV5DatePicker
        />
      </Grid>
      <Grid item className={classes.changeEntireSection}>
        <Radio
          checked={
            modificationType === ChangeResourceUserModificationType.Entirely
          }
          color="primary"
          inputProps={getAriaLabel(
            formatMessage({ id: 'changeResourceDialog.changeEntirely' })
          )}
          name="modificationType"
          onChange={onChangeTypeSelect}
          value={ChangeResourceUserModificationType.Entirely}
        />
        <FormattedMessage id="changeResourceDialog.changeEntirely" />
      </Grid>
    </Grid>
  );
};

ChangeResourceAllocationRangeOptions.propTypes = {
  asOfDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    .isRequired,
  modificationType: PropTypes.string.isRequired,
  onAsOfDateChange: PropTypes.func.isRequired,
  onChangeTypeSelect: PropTypes.func.isRequired
};

export default ChangeResourceAllocationRangeOptions;
